  <div class="rating">
    <span [class]="getStyleStar(1)"style="font-size:20px;color:#ffc107"></span>
    <span [class]="getStyleStar(2)"style="font-size:20px;color:#ffc107"></span>
    <span [class]="getStyleStar(3)"style="font-size:20px;color:#ffc107"></span>
    <span [class]="getStyleStar(4)"style="font-size:20px;color:#ffc107"></span>
    <span [class]="getStyleStar(5)"style="font-size:20px;color:#ffc107"></span>
  </div>

